import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ValuesView from "../views/ValuesView.vue";
import ContactView from "../views/ContactView.vue";
import CareersView from "../views/CareersView.vue";
import ServicesView from "../views/ServicesView.vue";
import Feedback from "../views/FeedbackView.vue";

const router = createRouter({
  //history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory("/"),
  scrollBehavior() {
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomeView,
      meta: {
        title: "Ajonee | NDIS Disability Support Services Australia",
        description:
          "Ajonee provides compassionate, person-centred disability support that empowers individuals to live with dignity, independence, and joy.",
      },
    },
    {
      path: "/about",
      name: "About",
      component: AboutView,
      meta: {
        title: "About Us | Ajonee Disability Support Services",
        description:
          "Learn about Ajonee's mission, team, and person-centred approach to disability support across Australia.",
      },
    },
    {
      path: "/values",
      name: "Values",
      component: ValuesView,
      meta: {
        title: "Our Values | Ajonee Disability Support Services",
        description:
          "Discover the values that guide Ajonee's approach to compassionate, dignified disability support.",
      },
    },
    {
      path: "/contact",
      name: "Contact",
      component: ContactView,
      meta: {
        title: "Contact Us | Ajonee Disability Support Services",
        description:
          "Get in touch with Ajonee to discuss disability support services tailored to you or your loved one.",
      },
    },
    {
      path: "/careers",
      name: "Careers",
      component: CareersView,
      meta: {
        title: "Careers | Join the Ajonee Team",
        description:
          "Explore careers with Ajonee and help empower people with disability to live independent, thriving lives.",
      },
    },
    {
      path: "/services",
      name: "Services",
      component: ServicesView,
      meta: {
        title: "Our Services | Ajonee Disability Support Services",
        description:
          "Explore Ajonee's range of NDIS-aligned disability support services, from daily living support to community access.",
      },
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      meta: {
        title: "Feedback | Ajonee Disability Support Services",
        description: "Share your feedback or a complaint with Ajonee. We welcome input to keep improving our services.",
      },
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: () => import("../views/PrivacyPolicyView.vue"),
      meta: {
        title: "Privacy Policy | Ajonee",
        description: "How Ajonee collects, uses, and protects your personal information.",
      },
    },
    {
      path: "/terms-of-use",
      name: "TermsOfUse",
      component: () => import("../views/TermsOfUseView.vue"),
      meta: {
        title: "Terms of Use | Ajonee",
        description: "The terms and conditions that apply to using the Ajonee website.",
      },
    },
    {
      path: "/cookie-policy",
      name: "CookiePolicy",
      component: () => import("../views/CookiePolicyView.vue"),
      meta: {
        title: "Cookie Policy | Ajonee",
        description: "How Ajonee uses cookies and similar technologies on this website.",
      },
    },
  ],
});

const DEFAULT_TITLE = "Ajonee | NDIS Disability Support Services Australia";
const DEFAULT_DESCRIPTION =
  "Ajonee provides compassionate, person-centred disability support that empowers individuals to live with dignity, independence, and joy.";
const SITE_URL = "https://ajonee.com.au";

function setMetaTag(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

router.afterEach((to) => {
  const title = to.meta?.title || DEFAULT_TITLE;
  const description = to.meta?.description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${to.path}`;

  document.title = title;
  setMetaTag("name", "description", description);
  setMetaTag("property", "og:title", title);
  setMetaTag("property", "og:description", description);
  setMetaTag("property", "og:url", url);
  setMetaTag("name", "twitter:title", title);
  setMetaTag("name", "twitter:description", description);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
});

export default router;
